import React, { createContext, useCallback, useContext, useEffect, useRef, useState } from 'react';
import './DiveTransition.css';

const DiveContext = createContext(null);

const LABELS = {
  curso: 'Entrando no curso',
  artigo: 'Abrindo artigo',
  artigos: 'Indo para Artigos',
  trilha: 'Abrindo trilha',
  trilhas: 'Indo para Trilhas',
  cursos: 'Indo para Cursos',
  plano: 'Abrindo o plano de hoje',
};

const DURATION = 2200;
// A água cobre a tela por volta de 1,6s: é quando a navegação acontece, por baixo do overlay
const NAVIGATE_AT = 1600;
const WAVE = 'M0 30 Q 90 0 180 30 T 360 30 T 540 30 T 720 30 T 900 30 T 1080 30 T 1260 30 T 1440 30 T 1620 30 '
  + 'T 1800 30 T 1980 30 T 2160 30 T 2340 30 T 2520 30 V 80 H 0 Z';

const RINGS = [
  [0.45, 220, 'rgba(164,220,0,.9)'],
  [0.6, 420, 'rgba(164,220,0,.6)'],
  [0.78, 700, 'rgba(255,255,255,.45)'],
  [0.95, 1100, 'rgba(164,220,0,.35)'],
];

/**
 * Animação de "mergulho" (gota, anéis e água subindo) antes de entrar num curso ou artigo.
 * Fica acima das rotas, então continua visível enquanto a página nova monta por baixo.
 */
export function DiveProvider({ children }) {
  const [dive, setDive] = useState(null);
  const timers = useRef([]);

  useEffect(() => () => timers.current.forEach(clearTimeout), []);

  /** @param kind curso | artigo | artigos | trilha | trilhas | plano; go: a navegação, chamada com a tela coberta */
  const start = useCallback((kind, go) => {
    const reduced = window.matchMedia?.('(prefers-reduced-motion: reduce)').matches;
    if (reduced) {
      go();
      return;
    }
    timers.current.forEach(clearTimeout);
    setDive({ key: Date.now(), kind });
    timers.current = [
      setTimeout(go, NAVIGATE_AT),
      setTimeout(() => setDive(null), DURATION),
    ];
  }, []);

  return (
    <DiveContext.Provider value={start}>
      {children}
      {dive && (
        <div className="dive" key={dive.key} aria-hidden="true">
          <span className="dive__drop" />
          <div className="dive__rings">
            {RINGS.map(([delay, size, color]) => (
              <span key={size} style={{ width: size, height: size, borderColor: color, animationDelay: `${delay}s` }} />
            ))}
          </div>
          <div className="dive__water">
            <svg className="dive__wave dive__wave--back" viewBox="0 0 2520 80" preserveAspectRatio="none"><path d={WAVE} /></svg>
            <svg className="dive__wave dive__wave--front" viewBox="0 0 2520 80" preserveAspectRatio="none"><path d={WAVE} /></svg>
            <div className="dive__body" />
          </div>
          <span className="dive__label"><span>&lt;</span>{LABELS[dive.kind]}<span>/&gt;</span></span>
        </div>
      )}
    </DiveContext.Provider>
  );
}

/** dive(kind, go): roda a animação e chama go() com a tela coberta. Sem o provider, só navega. */
export function useDive() {
  const start = useContext(DiveContext);
  return start || ((kind, go) => go());
}
